import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getFlashcardStatusCounts } from "../data/flashcardsRepo";

export default function useFlashcardStats() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ total: 0, new: 0, learning: 0, known: 0 });
  const [loading, setLoading] = useState(true);

  const language = "de"; // TEMP

  useEffect(() => {
    if (!user?.uid) {
      setStats({ total: 0, new: 0, learning: 0, known: 0 });
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchStats() {
      setLoading(true);
      try {
        const counts = await getFlashcardStatusCounts({ uid: user.uid, language });
        if (!cancelled) setStats(counts);
      } catch (err) {
        console.error("Erro ao buscar flashcards:", err);
        if (!cancelled) setStats({ total: 0, new: 0, learning: 0, known: 0 });
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchStats();

    return () => {
      cancelled = true;
    };
  }, [user?.uid, language]);

  return { stats, loading };
}
